document.addEventListener("DOMContentLoaded", function () {
    const variantBoxes = document.querySelectorAll(".variant-box");
    const variantName = document.getElementById("variant-name");
    const variantInput = document.getElementById("selected-variant-id");
    const buttonPrice = document.getElementById("button-price");
    const slideshowWrapper = document.getElementById("slideshow-wrapper");
    const slideshowDots = document.getElementById("slideshow-dots");
    const mainProductGallery = document.getElementById("main-product-gallery");
    let slideshowInterval;
    let startX = 0;
    let endX = 0;
    let isDragging = false;
    let autoSlideDelay = 3000; // Time for each slide

    // Function to get URL parameters
    function getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    // Function to find variant by ID
    function findVariantById(variantId) {
        return Array.from(variantBoxes).find(box => box.dataset.variantId === variantId);
    }

    function updateVariantDetails(variantElement) {
        const variantId = variantElement.dataset.variantId;
        const variantTitle = variantElement.dataset.variantTitle;
        const variantPriceValue = variantElement.dataset.variantPrice;

        variantName.textContent = variantTitle;
        buttonPrice.textContent = variantPriceValue;
        variantInput.value = variantId;

        const galleryContainer = variantElement.querySelector(".variant-gallery");
        let images = Array.from(galleryContainer.querySelectorAll("img")).map((img) => img.src);

        if (images.length === 0) {
            // Get the variant's full quality main image from the data attribute
            const variantMainImage = variantElement.dataset.variantFullImage;
            // Get all images from main product gallery
            const mainGalleryImages = Array.from(mainProductGallery.querySelectorAll("img")).map((img) => img.src);
            
            // Add variant main image as first image, then add all main gallery images
            images = [variantMainImage, ...mainGalleryImages];
        }

        updateSlideshow(images);
    }

    function updateSlideshow(images) {
        clearInterval(slideshowInterval);
        slideshowWrapper.innerHTML = "";
        slideshowDots.innerHTML = "";

        if (images.length === 0) return;

        images.forEach((image, index) => {
            let slide = document.createElement("div");
            slide.classList.add("slide");
            slide.style.backgroundImage = `url(${image})`;
            if (index === 0) slide.classList.add("active");
            slideshowWrapper.appendChild(slide);

            let dot = document.createElement("span");
            dot.classList.add("dot");
            if (index === 0) dot.classList.add("active");  
            dot.dataset.index = index;
            dot.addEventListener("click", () => {
                resetSlideshowTimer();
                showSlide(index);
            });
            slideshowDots.appendChild(dot);
        });

        startSlideshow();
        addSwipeAndDragEvents();
    }

    function showSlide(index) {
        const slides = document.querySelectorAll(".slide");
        const dots = document.querySelectorAll(".dot");

        slides.forEach((slide) => slide.classList.remove("active"));
        dots.forEach((dot) => dot.classList.remove("active"));

        slides[index].classList.add("active");
        dots[index].classList.add("active");
    }

    function startSlideshow() {
        return false;
        let index = 0;
        const slides = document.querySelectorAll(".slide");
        if (slides.length === 0) return;

        slideshowInterval = setInterval(() => {
            index = (index + 1) % slides.length;
            showSlide(index);
        }, autoSlideDelay);
    }

    function resetSlideshowTimer() {
        clearInterval(slideshowInterval);
        startSlideshow();
    }

    function addSwipeAndDragEvents() {
        let isPinching = false;
    
        slideshowWrapper.addEventListener("touchstart", (event) => {
            if (event.touches.length > 1) {
                isPinching = true; // User is zooming, not swiping
                return;
            }
            isPinching = false;
            startX = event.touches[0].clientX;
        });
    
        slideshowWrapper.addEventListener("touchmove", (event) => {
            if (isPinching || event.touches.length > 1) return; // Ignore if pinching
            endX = event.touches[0].clientX;
        });
    
        slideshowWrapper.addEventListener("touchend", () => {
            if (!isPinching) {
                handleSwipe();
            }
        });
    
        slideshowWrapper.addEventListener("mousedown", (event) => {
            isDragging = true;
            startX = event.clientX;
        });
    
        slideshowWrapper.addEventListener("mousemove", (event) => {
            if (isDragging) {
                endX = event.clientX;
            }
        });
    
        slideshowWrapper.addEventListener("mouseup", () => {
            isDragging = false;
            handleSwipe();
        });
    
        slideshowWrapper.addEventListener("mouseleave", () => {
            isDragging = false;
        });
    }
    

    function handleSwipe() {
        const slides = document.querySelectorAll(".slide");
        let activeIndex = [...slides].findIndex((slide) => slide.classList.contains("active"));
        let newIndex = activeIndex;

        if (startX - endX > 50) {
            newIndex = (activeIndex + 1) % slides.length;
        } else if (endX - startX > 50) {
            newIndex = (activeIndex - 1 + slides.length) % slides.length;
        }

        showSlide(newIndex);
        resetSlideshowTimer(); // Reset timer when manually switching
    }

    function highlightSelectedVariant(selectedBox) {
        variantBoxes.forEach((box) => box.classList.remove("selected"));
        selectedBox.classList.add("selected");
    }

    variantBoxes.forEach((box) => {
        box.addEventListener("click", function () {
            highlightSelectedVariant(box);
            updateVariantDetails(box);
        });
    });

    // Check for variantId in URL parameter and select the appropriate variant
    const urlVariantId = getUrlParameter('variantId');
    if (urlVariantId) {
        const targetVariant = findVariantById(urlVariantId);
        if (targetVariant) {
            highlightSelectedVariant(targetVariant);
            updateVariantDetails(targetVariant);
        } else {
            // Fallback to first variant if URL variant not found
            if (variantBoxes.length > 0) {
                highlightSelectedVariant(variantBoxes[0]);
                updateVariantDetails(variantBoxes[0]);
            }
        }
    } else {
        // Default behavior - select first variant
        if (variantBoxes.length > 0) {
            highlightSelectedVariant(variantBoxes[0]);
            updateVariantDetails(variantBoxes[0]);
        }
    }


    
});

//** Video stuff */

const video = document.querySelector(".product-expanded-form .background-video");
const placeholder = document.querySelector(".product-expanded-form .video-placeholder");

checkforVideo();

function checkforVideo() {
    //Every 500ms, check if the video element has loaded
    var b = setInterval(()=>{
        if(video.readyState >= 3){
            
        placeholder.style.display = "none"; // Hide placeholder when video is ready
        video.style.display = "block"; // Show video
            clearInterval(b);

        }                   
    },500);
}


document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
        const item = header.parentElement;
        const isActive = item.classList.contains('active');
        document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));
        if (!isActive) {
            item.classList.add('active');
        }
    });
});
